<template>
  <transition name="fade">
    <div
      v-if="isVisible"
      class="notification-screen problem-screen"
      @click="toggleProblemScreen">
      <div class="notification-screen-box">
        <div class="floating-container">
          <jLottie
            :options="defaultOptions"
            :height="250"
            :width="250"
            class="animation"
            @animCreated="handleAnimation"/>
          <h1
            class="title">
            Problem
          </h1>
          <h2
            class="message code m__b--0"
            @click="click">{{ code }}</h2>
          <h2
            v-if="isMessageArray"
            id="problem-screen-message"
            class="message m__t--5">
            <div
              v-for="(item, index) in message"
              :key="index">
              {{ item }}
            </div>
          </h2>
          <h2
            v-else
            id="problem-screen-message"
            class="message m__t--5">
            {{ message }}
          </h2>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import jLottie from '@/components/lottie/jLottie';
import * as animationData from '@/assets/json/error.json';

export default {
  name: 'JProblemScreen',
  components: {
    jLottie,
  },
  props: {
    message: {
      type: [String, Array],
      default: '',
    },
    code: {
      type: [String, Number],
      default: null,
    },
    url: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      defaultOptions: {
        animationData,
      },
      animationSpeed: 1,
      isVisible: false,
    };
  },
  computed: {
    isMessageArray() {
      if (Array.isArray(this.message)) {
        return true;
      }
      return false;
    },
  },
  methods: {
    handleAnimation(anim) {
      this.anim = anim;
    },
    toggleProblemScreen() {
      this.isVisible = !this.isVisible;
    },
    showProblemScreen() {
      this.isVisible = true;
    },
    hideProblemScreen() {
      this.isVisible = false;
    },
    click() {
      if (this.code !== null && this.url !== '') {
        window.open(
          this.url + this.code,
          '_blank',
        );
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/notification-screen/jProblemScreen.vue